import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmModal from './ConfirmModal';
import { PUSH_ASK_EVENT, enablePush } from '../native/push';

/**
 * Before the system asks for notifications (once, in the app), say what they bring:
 * answers, approvals and finished work from bots, with replies right from them.
 */
export default function PushPromptDialog() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener(PUSH_ASK_EVENT, show);
    return () => window.removeEventListener(PUSH_ASK_EVENT, show);
  }, []);

  return (
    <ConfirmModal
      isOpen={open}
      onClose={() => setOpen(false)}
      onConfirm={() => { setOpen(false); enablePush(); }}
      title={t('push.prompt.title')}
      message={t('push.prompt.text')}
      confirmLabel={t('push.prompt.turn_on')}
    />
  );
}
